import { render, staticRenderFns } from "./Contact1920.vue?vue&type=template&id=472fabe2&scoped=true"
import script from "./Contact1920.vue?vue&type=script&lang=js"
export * from "./Contact1920.vue?vue&type=script&lang=js"
import style0 from "./Contact1920.vue?vue&type=style&index=0&id=472fabe2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472fabe2",
  null
  
)

export default component.exports